import { Card, Layout, Row, Tabs } from 'antd'
import EmailList from 'components/Main/Emails/EmailList'
import CustomBreadCrumb from '../../../components/Common/CustomBreadCrumb'
import PageTitle from '../../../elements/PageTitle'
import React, { Fragment } from 'react'

const { Content } = Layout

function Email(props) {
  if (props.owner) {
    return <EmailList {...props} />
  }

  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <CustomBreadCrumb items={[{ text: 'Emails' }]} />
            <PageTitle title={'Emails'} subtitle={'Manage Your Emails.'} color={'#FF6138'} iconType={'emailt'} />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <EmailList {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

export default Email
